<template lang="pug">
  #confirm-neo-data
    h4.mx-2.mt-1.mb-4.text-center.border.message-border-style.border-primary.rounded.p-3 送信前に入力内容をご確認ください。
    b-container(fluid="fluid")
      b-row(v-if="regist_data.plan.type!=='chatluck'")
        b-col
          b-row.pb-0.mr-0(:class="plan_service_title_class")
            h5.font-weight-bold.mr-2 {{plans[regist_data.plan.type || ''].title}}
            .mr-3(v-if="plans[regist_data.plan.type || ''].services.includes('neo')")
              img.logo_desknets.pb-2(src="@/assets/images/logo_desknetsneo_clear_background.png")
            .mr-3(v-if="plans[regist_data.plan.type || ''].services.includes('appsuite')")
              img.logo_appsuite(src="@/assets/images/logo_appsuite.png")
            .mr-3(v-if="plans[regist_data.plan.type || ''].services.includes('chatluck')")
              img.logo_chatluck(src="@/assets/images/logo_chatluck.png")
            h5.font-weight-bold （1ユーザー￥{{plans[regist_data.plan.type || ''].price.toLocaleString()}}/月）
            b-button.anchor-button.ml-2(size="sm", :to="{name: 'SelectPlan'}") 修正
          b-form-text(:class="plan_service_data_class") {{regist_data.plan.user}} ユーザー
      b-form-text(v-if="regist_data.plan.type!=='chatluck'" style="height: 30px;")
      template(v-if="['light', 'standard', 'premium', 'chatplus'].indexOf(regist_data.plan.type) !== -1")
        h4.font-weight-bold desknet's NEOご利用サービス
        b-row
          b-col
            template(v-if="(regist_data.plan.type === 'light' || regist_data.plan.type === 'chatplus') && regist_data.neo.app_suite_user")
              h5(:class="neo_service_title_class") 業務アプリ作成ツール AppSuite（1ユーザー￥550/月）
                b-button.anchor-button.ml-2(size="sm", :to="{name: 'InputServiceContents', hash: '#app-suite-user', params: { service_type: 'neo' }}") 修正
              b-form-text(:class="neo_service_data_class") {{regist_data.neo.app_suite_user}} ユーザー
              b-form-text(style="height: 30px;")
            template(v-if="regist_data.neo.web_conferencing")
              h5(:class="neo_service_title_class") desknet's NEO ウェブ会議（1会議室￥11,000/月）
                b-button.anchor-button.ml-2(size="sm", :to="{name: 'InputServiceContents', hash: '#web-conferencing', params: { service_type: 'neo' }}") 修正
              b-form-text(:class="neo_service_data_class") {{regist_data.neo.web_conferencing}} 会議室
              b-form-text(style="height: 30px;")
            template(v-if="regist_data.neo.option && Object.keys(regist_data.neo.option).length > 0")
              h5(:class="neo_service_title_class") オプションサービス
                b-button.anchor-button.ml-2(size="sm", :to="{name: 'InputServiceContents', hash: '#neo-option-service', params: { service_type: 'neo', anchor: 'neo_option_service'}}") 修正
              b-form-text(v-if="regist_data.neo.option.room_mgr" :class="neo_option_data_class") RoomMgr（￥22,000/月）： 利用する
              b-form-text(v-if="regist_data.neo.option.expense_settlement" :class="neo_option_data_class") 交通費経費精算（1ユーザー￥110/月）： 利用する
              b-form-text(v-if="regist_data.neo.option.clouza" :class="neo_option_data_class") タイムカード＋CLOUZA（10ユーザー￥2,200/月）
                b-row
                  b-col(cols="1")
                  b-col
                    b-form-text.text-left {{regist_data.neo.option.clouza.user}} ユーザー
                    b-form-text.text-left(v-if="regist_data.neo.option.clouza.clouza_company") お試し環境からの引き継ぎコード : {{regist_data.neo.option.clouza.clouza_company}}
                    b-form-text.text-left(v-if="regist_data.neo.option.clouza.paid_leave_option") 有休管理＋申請承認オプション（10ユーザー￥1,650/月）
              b-form-text(v-if="regist_data.neo.option.disk" :class="neo_option_data_class") ディスク増設（20GBあたり￥2,200/月）
                b-row
                  b-col(cols="1")
                  b-col
                    b-form-text.text-left 20GB × {{regist_data.neo.option.disk.disk_size}} = {{regist_data.neo.option.disk.disk_size * 20}} GB増設
              b-form-text(v-if="regist_data.neo.option.sync" :class="neo_option_data_class") Sync for smartphones（1ユーザー￥220/月）
                b-row
                  b-col(cols="1")
                  b-col
                    b-form-text.text-left {{regist_data.neo.option.sync.user}} ユーザー
              //- desknet'sドライブ ディスク増設
              b-form-text(v-if="regist_data.neo.option.dn_drive" :class="neo_option_data_class") desknet'sドライブ ディスク増設（20GBあたり￥2,200/月）
                b-row
                  b-col(cols="1")
                  b-col
                    b-form-text.text-left 20GB × {{regist_data.neo.option.dn_drive.disk_size}} = {{regist_data.neo.option.dn_drive.disk_size * 20}} GB増設
              b-form-text(style="height: 30px;" :class="neo_option_data_class")
            template(v-if="regist_data.neo.security && Object.keys(regist_data.neo.security).length > 0")
              h5(:class="neo_service_title_class") セキュリティオプション
                b-button.anchor-button.ml-2(size="sm", :to="{name: 'InputServiceContents', hash: '#neo-security-option', params: { service_type: 'neo', anchor: 'neo_security_option'}}") 修正
              b-form-text(v-if="regist_data.neo.security.basic" :class="neo_option_data_class") BASIC認証 (無償)
                b-row
                  b-col(cols="1")
                  b-col
                    b-form-text.text-left ユーザーID ： {{regist_data.neo.security.basic.basic_id}}
                    basic-password(form_name="パスワード", :password="regist_data.neo.security.basic.basic_password")
                    template(v-if="regist_data.neo.security.basic.basic_except_ip")
                      b-form-text.text-left 認証を除外するIPアドレス：
                      b-form-text.text-left.ml-1(v-for="(ip_addr) of basic_except_ip") {{ip_addr}}
              b-form-text(v-if="regist_data.neo.security.connect_permit_ip" :class="neo_option_data_class") 接続元IPアドレス制限
                b-row
                  b-col(cols="1")
                  b-col
                    b-form-text.text-left 接続を許可するIPアドレス：
                    b-form-text.text-left.ml-1(v-for="(ip_addr) of connect_permit_ip") {{ip_addr}}
              //b-form-text(v-if="regist_data.neo.security.secure" :class="neo_option_data_class") セキュアブラウザ（1ユーザー￥110/月 または 1デバイス￥385/月）
                b-row
                  b-col(cols="1")
                  b-col
                    b-form-text.text-left 端末認証：{{secure_browser_terminal}}
                    b-form-text.text-left(v-if="regist_data.neo.security.secure.secure_browser_terminal==='02'") デバイス数：{{regist_data.neo.security.secure.secure_browser_device}} デバイス
                    template(v-if="this.regist_data.neo.security.secure.secure_except_ip")
                      b-form-text.text-left セキュアブラウザを適用しないIPアドレス：
                      b-form-text.text-left.ml-1(v-for="(ip_addr) of secure_except_ip") {{ip_addr}}
              b-form-text(v-if="regist_data.neo.security.client" :class="neo_option_data_class") クライアント認証（1デバイス￥220/月）
                b-row
                  b-col(cols="1")
                  b-col
                    b-form-text.text-left {{regist_data.neo.security.client.device}} デバイス
                    template(v-if="this.regist_data.neo.security.client.cert_except_ip")
                      b-form-text.text-left 認証を除外するIPアドレス：
                      b-form-text.text-left.ml-1(v-for="(ip_addr) of cert_except_ip") {{ip_addr}}
              b-form-text(style="height: 30px;" :class="neo_option_data_class")
            template(v-if="regist_data.neo.mail && Object.keys(regist_data.neo.mail).length > 0")
              h5(:class="neo_service_title_class") メールサービス
                b-button.anchor-button.ml-2(size="sm", :to="{name: 'InputServiceContents', hash: '#neo-mail-service', params: { service_type: 'neo', anchor: 'neo_mail_service'}}") 修正
              b-form-text(v-if="regist_data.neo.mail.arena" :class="neo_option_data_class") WebARENA（1アカウント￥220/月）
                b-row
                  b-col(cols="1")
                  b-col
                    b-form-text.text-left 利用ドメイン名 ： {{regist_data.neo.mail.arena.wa_domain}}
                    b-form-text.text-left アカウント数 ： {{regist_data.neo.mail.arena.account}} アカウント
              b-form-text(v-if="regist_data.neo.mail.cyber" :class="neo_option_data_class") CYBERMAILΣ（1アカウント￥220～/月、初期￥22,000～）
                b-row
                  b-col(cols="1")
                  b-col
                    b-form-text.text-left アカウント数 ： {{regist_data.neo.mail.cyber.account}} アカウント
                    b-form-text.text-left.mb-2 メールボックス容量 ： {{cyber_capacity}}
                    template(v-if="regist_data.neo.mail.cyber.options")
                      b-form-text.font-weight-bold.text-left.mb-1 オプション
                      b-form-text.text-left(v-if="regist_data.neo.mail.cyber.options.indexOf('00') !== -1") ・情報漏えい対策(有償)を利用する
                      b-form-text.text-left(v-if="regist_data.neo.mail.cyber.options.indexOf('01') !== -1") ・添付ファイル暗号化・分離(有償)を利用する
                      template(v-if="regist_data.neo.mail.cyber.options.indexOf('02') !== -1")
                        b-form-text.text-left ・メールアーカイブ＆監査(有償)を利用する
                        b-form-text.text-left.ml-3 （ {{mail_keep}} )
                      b-form-text.text-left(v-if="regist_data.neo.mail.cyber.options.indexOf('03') !== -1").mb-2 ・クラウド型サンドボックス(有償)を利用する
              b-form-text(style="height: 30px;" :class="neo_option_data_class")
            template(v-if="regist_data.neo.mail_security && Object.keys(regist_data.neo.mail_security).length > 0")
              h5(:class="neo_service_title_class") メールセキュリティサービス
                b-button.anchor-button.ml-2(size="sm", :to="{name: 'InputServiceContents', hash: '#neo-mail-security-service', params: { service_type: 'neo', anchor: 'neo_mail_security_service'}}") 修正
              b-form-text(v-if="regist_data.neo.mail_security.mailgates" :class="neo_option_data_class") MAILGATES Σ（1アカウント￥110～/月、初期￥55,000～）
                b-row
                  b-col(cols="1")
                  b-col
                    b-form-text.text-left 利用ドメイン名 ： {{regist_data.neo.mail_security.mailgates.mailgates_domain}}
                    b-form-text.text-left.mb-2 アカウント数 ： {{regist_data.neo.mail_security.mailgates.account}} アカウント
                    template(v-if="regist_data.neo.mail_security.mailgates.options")
                      b-form-text.font-weight-bold.text-left.mb-1 オプション
                      b-form-text.text-left(v-if="regist_data.neo.mail_security.mailgates.options.indexOf('01') !== -1") ・アンチウイルス・スパム＋サンドボックスを利用する
                      b-form-text.text-left(v-if="regist_data.neo.mail_security.mailgates.options.indexOf('02') !== -1") ・誤送信対策・審査を利用する
                      b-form-text.text-left(v-if="regist_data.neo.mail_security.mailgates.options.indexOf('03') !== -1").mb-2 ・添付ファイル暗号化・分離を利用する
              b-form-text(style="height: 30px;" :class="neo_option_data_class")
            //h5(:class="neo_service_title_class") ご利用開始希望日
            //  b-button.anchor-button.ml-2(size="sm", :to="{name: 'InputServiceContents', hash: '#option-service', params: { service_type: 'neo', anchor: 'option_service'}}") 修正
            //b-form-text(:class="neo_service_data_class") 2021年10月28日(木)
            //b-form-text(style="height: 30px;")
            h5(:class="neo_service_title_class") ご希望サブドメイン名
              b-button.anchor-button.ml-2(size="sm", :to="{name: 'InputServiceContents', hash: '#neo-sub-domain', params: { service_type: 'neo' }}") 修正
            b-form-text(:class="neo_service_data_class") {{regist_data.neo.sub_domain}}.dn-cloud.com
            b-form-text(style="height: 30px;")
            template(v-if="regist_data.neo.migration_url")
              h5(:class="neo_service_title_class") 無料お試し版からのデータ移行
                b-button.anchor-button.ml-2(size="sm", :to="{name: 'InputServiceContents', hash: '#neo-migration-url', params: { service_type: 'neo', anchor: 'neo_migration_url'}}") 修正
              b-form-text(:class="neo_option_data_class") 希望する
              b-form-text.pb-2(:class="neo_no_border_top") 試使用環境URL：{{regist_data.neo.migration_url}}
              //b-form-text.pb-2(:class="neo_no_border_top") 作業日時 ： 2021年10月14日(木) 11:00 - 12:00
              b-form-text(style="height: 30px;")
      template(v-if="['premium', 'chatplus', 'chatluck'].indexOf(regist_data.plan.type) !== -1")
        h4.font-weight-bold ChatLuckご利用サービス
        b-row
          b-col
            template(v-if="regist_data.plan.type === 'chatluck'")
              h5(:class="chat_service_title_class") ビジネスチャット ChatLuck（1ユーザー￥330/月）
                b-button.anchor-button.ml-2(size="sm", :to="{name: 'InputServiceContents', hash: '#plan', params: { service_type: 'chat'}}") 修正
              b-form-text(:class="chat_service_data_class") {{regist_data.chat.chat_user}} ユーザー
              b-form-text(style="height: 30px;")
            template(v-if="regist_data.chat.option && Object.keys(regist_data.chat.option).length > 0")
              h5(:class="chat_service_title_class") オプションサービス
                b-button.anchor-button.ml-2(size="sm", :to="{name: 'InputServiceContents', hash: '#chat-option-service', params: { service_type: 'chat', anchor: 'chat_option_service'}}") 修正
              b-form-text(v-if="regist_data.chat.option.disk" :class="chat_service_data_class") ディスク増設（20GBあたり￥1,100/月）
                b-row
                  b-col(cols="1")
                  b-col
                    b-form-text.text-left 20GB × {{regist_data.chat.option.disk.disk_size}} = {{regist_data.chat.option.disk.disk_size*20}}GB増設
              b-form-text(style="height: 30px;")
            template(v-if="regist_data.chat.security && Object.keys(regist_data.chat.security).length > 0")
              h5(:class="chat_service_title_class") セキュリティオプション
                b-button.anchor-button.ml-2(size="sm", :to="{name: 'InputServiceContents', hash: '#chat-security-option', params: { service_type: 'chat', anchor: 'chat_security_option'}}") 修正
              b-form-text(v-if="regist_data.chat.security.basic" :class="chat_option_data_class") BASIC認証 (無償)
                b-row
                  b-col(cols="1")
                  b-col
                    b-form-text.text-left ユーザーID ： {{regist_data.chat.security.basic.basic_id}}
                    basic-password(form_name="パスワード", :password="regist_data.chat.security.basic.basic_password")
                    template(v-if="regist_data.chat.security.basic.basic_except_ip")
                      b-form-text.text-left 認証を除外するIPアドレス：
                      b-form-text.text-left.ml-1(v-for="(ip_addr) of basic_except_ip_chat") {{ip_addr}}
              b-form-text(v-if="regist_data.chat.security.connect_permit_ip" :class="chat_option_data_class") 接続元IPアドレス制限
                b-row
                  b-col(cols="1")
                  b-col
                    b-form-text.text-left 接続を許可するIPアドレス：
                    b-form-text.text-left.ml-1(v-for="(ip_addr) of connect_permit_ip_chat") {{ip_addr}}
              b-form-text(style="height: 30px;" :class="chat_option_data_class")
            //h5(:class="chat_service_title_class") ご利用開始希望日
            //  b-button.anchor-button.ml-2(size="sm", :to="{name: 'InputServiceContents', hash: '#chat-preferred-date', params: { service_type: 'chat', anchor: 'chat_preferred_date'}}") 修正
            //b-form-text(:class="chat_service_data_class") 2021年10月28日(木)
            //b-form-text(style="height: 30px;")
            h5(:class="chat_service_title_class") ご希望サブドメイン名
              b-button.anchor-button.ml-2(size="sm", :to="{name: 'InputServiceContents', hash: '#chat-sub-domain', params: { service_type: 'chat' }}") 修正
            b-form-text(:class="chat_service_data_class") {{regist_data.chat.sub_domain}}.chatluck.net
            b-form-text(style="height: 30px;")
            template(v-if="regist_data.chat.migration_url")
              h5(:class="chat_service_title_class") 無料お試し版からのデータ移行
                b-button.anchor-button.ml-2(size="sm", :to="{name: 'InputServiceContents', hash: '#chat-migration-url', params: { service_type: 'chat', anchor: 'chat_migration_url'}}") 修正
              b-form-text(:class="chat_option_data_class") 希望する
              b-form-text.pb-2(:class="chat_no_border_top") 試使用環境URL：{{regist_data.chat.migration_url}}
              //b-form-text.pb-2(:class="chat_no_border_top") 作業日時 ： 2021年10月14日(木) 11:00 - 12:00
              b-form-text(style="height: 30px;")
      template(v-if="(regist_data.neo && regist_data.neo.migration_url) || (regist_data.chat && regist_data.chat.migration_url)")
        h5(:class="customer_service_title_class") 無料お試し版からのデータ移行作業日時
          b-button.anchor-button.ml-2(size="sm", :to="{name: 'InputServiceContents', hash: '#migration-date', params: { service_type: getReturnServiceTypeMigrationDate, anchor: 'migration_date'}}") 修正
        b-form-text(:class="customer_service_data_class") {{migration_date}}
        b-form-text(style="height: 30px;")
      template(v-else)
        h5(:class="customer_service_title_class") ご利用開始希望日
          b-button.anchor-button.ml-2(size="sm", :to="{name: 'InputServiceContents', hash: '#preferred-date', params: { anchor: 'preferred_date'}}") 修正
        b-form-text(:class="customer_service_data_class") {{preferred_date}}
        b-form-text(style="height: 30px;")
      template(v-if="regist_data.estimate")
        h5(:class="customer_service_title_class") お見積番号
          b-button.anchor-button.ml-2(size="sm", :to="{name: 'InputServiceContents', hash: '#estimate', params: { anchor: 'estimate'}}") 修正
        b-form-text.pb-2(:class="customer_service_data_class") No ： {{estimate}}
        b-form-text(style="height: 30px;")
      template(v-if="regist_data.remarks")
        h5(:class="customer_service_title_class") 備考
          b-button.anchor-button.ml-2(size="sm", :to="{name: 'InputServiceContents', hash: '#remarks', params: { anchor: 'remarks'}}") 修正
        b-form-text.pb-2.white-space(:class="customer_service_data_class") {{regist_data.remarks}}
        b-form-text(style="height: 30px;")
      h4.font-weight-bold お客様情報
      b-row
        b-col
          h5(:class="customer_service_title_class") ご契約者情報
            b-button.anchor-button.ml-2(size="sm", :to="{name: 'FirstOrderCustomerInfo', hash: '#customer-info'}") 修正
          b-row.border-top.ml-3.mr-1
            b-col(cols="3", :class="customer_title_col_class") 会社名・組織名
            b-col(:class="customer_data_col_class")
              div {{regist_data.customer_info.firm_name}}
              template(v-if="regist_data.customer_info.foreign_company_flg")
                .ml-3 外国法人に該当します
          b-row.border-top.ml-3.mr-1
            b-col(cols="3", :class="customer_title_col_class") 会社名・組織名(かな)
            b-col(:class="customer_data_col_class") {{regist_data.customer_info.firm_kana}}
          b-row.border-top.ml-3.mr-1
            b-col(cols="3", :class="customer_title_col_class") 代表者名
            b-col(:class="customer_data_col_class") {{regist_data.customer_info.president_name}}
          b-row.border-top.ml-3.mr-1
            b-col(cols="3", :class="customer_title_col_class") 代表者名(かな)
            b-col(:class="customer_data_col_class") {{regist_data.customer_info.president_kana}}
          b-row.border-top.ml-3.mr-1
            b-col(cols="3", :class="customer_title_col_class") 部署名
            b-col(:class="customer_data_col_class") {{regist_data.customer_info.department}}
          b-row.border-top.ml-3.mr-1
            b-col(cols="3", :class="customer_title_col_class") 担当者名
            b-col(:class="customer_data_col_class") {{regist_data.customer_info.person_name}}
          b-row.border-top.ml-3.mr-1
            b-col(cols="3", :class="customer_title_col_class") 担当者名(かな)
            b-col(:class="customer_data_col_class") {{regist_data.customer_info.person_kana}}
          b-row.border-top.ml-3.mr-1
            b-col(cols="3", :class="customer_title_col_class") 郵便番号
            b-col(:class="customer_data_col_class") {{regist_data.customer_info.zip_code}}
          b-row.border-top.ml-3.mr-1
            b-col(cols="3", :class="customer_title_col_class") 住所
            b-col(:class="customer_data_col_class") {{customer_address}}
          b-row.border-top.ml-3.mr-1
            b-col(cols="3", :class="customer_title_col_class") 電話番号
            b-col(:class="customer_data_col_class") {{regist_data.customer_info.tel}}
          b-row.border-top.ml-3.mr-1
            b-col(cols="3", :class="customer_title_col_class") FAX番号
            b-col(:class="customer_data_col_class") {{regist_data.customer_info.fax}}
          b-row.border-top.border-bottom.ml-3.mr-1
            b-col(cols="3", :class="customer_title_col_class") E-mail
            b-col(:class="customer_data_col_class")  {{regist_data.customer_info['e-mail']}}
          b-form-text(style="height: 30px;")

          h5(:class="customer_service_title_class") ご契約種別・お支払い方法
            b-button.anchor-button.ml-2(size="sm", :to="{name: 'FirstOrderCustomerInfo', hash: '#contract-type'}") 修正
          b-row.border-top.ml-3.mr-1
            b-col(cols="3", :class="customer_title_col_class") ご契約種別
            b-col(:class="customer_data_col_class") {{contract_type}}
          b-row.border-top.border-bottom.ml-3.mr-1
            b-col(cols="3", :class="customer_title_col_class") お支払い方法
            b-col(:class="customer_data_col_class") {{payment_method}}
          b-form-text(style="height: 30px;")

          h5(:class="customer_service_title_class") 請求書宛名情報
            b-button.anchor-button.ml-2(size="sm", :to="{name: 'FirstOrderCustomerInfo', hash: '#send-invoice'}") 修正
          b-row.border-top.ml-3.mr-1
            b-col(cols="3", :class="customer_title_col_class") 会社名・組織名
            b-col(:class="customer_data_col_class") {{regist_data.customer_info.bill_firm_name || regist_data.customer_info.firm_name}}
          b-row.border-top.ml-3.mr-1
            b-col(cols="3", :class="customer_title_col_class") 会社名・組織名(かな)
            b-col(:class="customer_data_col_class") {{regist_data.customer_info.bill_firm_kana || regist_data.customer_info.firm_kana}}
          b-row.border-top.ml-3.mr-1
            b-col(cols="3", :class="customer_title_col_class") 部署名
            b-col(:class="customer_data_col_class") {{regist_data.customer_info.bill_department || regist_data.customer_info.department}}
          b-row.border-top.ml-3.mr-1
            b-col(cols="3", :class="customer_title_col_class") 担当者名
            b-col(:class="customer_data_col_class") {{regist_data.customer_info.bill_person_name || regist_data.customer_info.person_name}}
          b-row.border-top.ml-3.mr-1
            b-col(cols="3", :class="customer_title_col_class") 担当者名(かな)
            b-col(:class="customer_data_col_class") {{regist_data.customer_info.bill_person_kana || regist_data.customer_info.person_kana}}
          b-row.border-top.ml-3.mr-1
            b-col(cols="3", :class="customer_title_col_class") 郵便番号
            b-col(:class="customer_data_col_class") {{regist_data.customer_info.bill_zip_code || regist_data.customer_info.zip_code}}
          b-row.border-top.ml-3.mr-1
            b-col(cols="3", :class="customer_title_col_class") 住所
            b-col(:class="customer_data_col_class") {{bill_address}}
          b-row.border-top.ml-3.mr-1
            b-col(cols="3", :class="customer_title_col_class") 電話番号
            b-col(:class="customer_data_col_class") {{regist_data.customer_info.bill_tel || regist_data.customer_info.tel}}
          b-row.border-top.ml-3.mr-1
            b-col(cols="3", :class="customer_title_col_class") FAX番号
            b-col(:class="customer_data_col_class") {{regist_data.customer_info.bill_fax || regist_data.customer_info.fax}}
          b-row.border-top.border-bottom.ml-3.mr-1
            b-col(cols="3", :class="customer_title_col_class") E-mail
            b-col(:class="customer_data_col_class") {{regist_data.customer_info.bill_e_mail || regist_data.customer_info['e-mail']}}
          b-form-text(style="height: 30px;")

          h5(:class="customer_service_title_class") クラウド版サポートサイトご利用時のパスワード
            b-button.anchor-button.ml-2(size="sm", :to="{name: 'FirstOrderCustomerInfo', hash: '#password'}") 修正
          b-row.border-top.border-bottom.ml-3.mr-1
            b-col(cols="3", :class="customer_title_col_class") パスワード
            b-col(:class="customer_data_col_class") ●●●●●●●●●
          b-form-text(style="height: 30px;")

          payment-detail-list(:register_data="regist_data", :show_notice="{plan: true, neo: true, chat: true}", :contract_type="this.regist_data.customer_info.contract_type")
</template>

<script>
import { cl_client_tbl as lang_cl_client_tbl } from '@/lang/ja_JP'
import { od_order_tbl as lang_od_order_tbl } from '@/lang/ja_JP'
import PaymentDetailList from "@/components/PaymentDetailList"
import BasicPassword from '@/components/BasicPassword';

export default {
  name: "ConfirmNeoData",
  components: {
    PaymentDetailList,
    BasicPassword
  },
  props: {
    regist_data: { type: Object, required: true},
  },
  data() {
    return {
      plan_service_title_class: "font-weight-bold ml-3 border-top border-bottom pt-2 mb-2 plan-title-bg-color",
      plan_service_data_class: "ml-3 py-2 px-2 mb-2 border-top border-bottom plan-border-color label-font-size",

      neo_service_title_class: "font-weight-bold ml-3 border-top border-bottom py-2 title-bg-color",
      neo_service_data_class: "ml-3 py-2 px-2 mb-2 border-top border-bottom border-primary label-font-size",
      neo_option_data_class: "ml-3 pt-2 px-2 mb-0 border-top border-primary label-font-size",
      neo_option_data_last_class: "ml-3 pt-2 px-2 mb-2 border-top border-bottom border-primary label-font-size",
      neo_no_border_top: "ml-3 pt-2 px-2 mb-2 border-bottom border-primary label-font-size",

      chat_service_title_class: "font-weight-bold ml-3 border-top border-bottom py-2 chat-title-bg-color",
      chat_service_data_class: "ml-3 py-2 px-2 mb-2 border-top border-bottom border-success label-font-size",
      chat_option_data_class: "ml-3 pt-2 px-2 mb-0 border-top border-success label-font-size",
      chat_option_data_last_class: "ml-3 pt-2 px-2 mb-2 border-top border-bottom border-success label-font-size",
      chat_no_border_top: "ml-3 pt-2 px-2 mb-2 border-bottom border-success label-font-size",

      customer_service_title_class: "font-weight-bold ml-3 border-top border-bottom py-2 customer-title-bg-color",
      customer_service_data_class: "ml-3 py-2 px-2 mb-2 border-top border-bottom border-secondary label-font-size",
      customer_option_data_class: "ml-3 pt-2 px-2 mb-0 border-top border-success label-font-size",
      customer_option_data_last_class: "ml-3 pt-2 px-2 mb-2 border-top border-bottom border-success label-font-size",
      customer_no_border_top: "ml-3 pt-2 px-2 mb-2 border-bottom border-success label-font-size",

      customer_title_col_class: "py-2 px-2 border-right font-weight-bold",
      customer_data_col_class: "py-2 px-2 overflow",

      plans: {
        'light': { title: 'ライト', price: 660, services:['neo'], plan:'light'},
        'standard': { title: 'スタンダード', price: 880, services:['neo', 'appsuite'], plan:'standard' },
        'premium': { title: 'プレミアム', price: 1100, services:['neo', 'appsuite', 'chatluck'], plan:'premium' },
        'chatplus': { title: 'チャットプラス', price: 836, services:['neo', 'chatluck'], plan:'chatplus' },
        'chatluck': { title: 'ChatLuck', price: 330, services:['chatluck'], plan:'chatluck' },
        '': { title: '', price: '', services: [], plan: '' }
      },
    }
  },
  computed: {
    basic_except_ip() {
      // 半角区切りをカンマ区切りにして5つ毎に改行する
      return this.showItemsAsRow(this.regist_data.neo.security.basic.basic_except_ip, 5, '\n')
    },
    connect_permit_ip() {
      // 半角区切りをカンマ区切りにして5つ毎に改行する
      return this.showItemsAsRow(this.regist_data.neo.security.connect_permit_ip, 5, '\n')
    },
    secure_except_ip() {
      // 半角区切りをカンマ区切りにして5つ毎に改行する
      return this.showItemsAsRow(this.regist_data.neo.security.secure.secure_except_ip, 5, '\n')
    },
    cert_except_ip() {
      // 半角区切りをカンマ区切りにして5つ毎に改行する
      return this.showItemsAsRow(this.regist_data.neo.security.client.cert_except_ip, 5, '\n')
    },
    estimate() {
      // 半角区切りをカンマ区切りにして5つ毎に改行する
      return this.regist_data.estimate.replaceAll('\n', ',')
    },
    basic_except_ip_chat() {
      // 半角区切りをカンマ区切りにして5つ毎に改行する
      return this.showItemsAsRow(this.regist_data.chat.security.basic.basic_except_ip, 5, '\n')
    },
    connect_permit_ip_chat() {
      // 半角区切りをカンマ区切りにして5つ毎に改行する
      return this.showItemsAsRow(this.regist_data.chat.security.connect_permit_ip, 5, '\n')
    },
    preferred_date() {
      // 2021年12月2日(木) のような形式にする
      return this.showDateString(this.regist_data.preferred_date)
    },
    migration_date() {
      // 「2021年12月2日(木) 11:00 - 12:00」のような形式にする
      return this.showDateString(this.regist_data.migration_date, this.regist_data.migration_time_from, this.regist_data.migration_time_to)
    },
    customer_address() {
      // 入力した住所(都道府県 / 市区町村 / 丁目番地 / 建物名以下)を全て連結して表示する
      return (this.regist_data.customer_info.prefecture || '') + (this.regist_data.customer_info.city || '') + (this.regist_data.customer_info.address1 || '') + (this.regist_data.customer_info.address2 || '')
    },
    bill_address() {
      // 請求書宛名情報の住所(都道府県 / 市区町村 / 丁目番地 / 建物名以下)を全て連結して表示する
      return (this.regist_data.customer_info.bill_prefecture || '') + (this.regist_data.customer_info.bill_city || '') + (this.regist_data.customer_info.bill_address1 || '') + (this.regist_data.customer_info.bill_address2 || '')
    },
    // 無料お試し版からのデータ移行作業日時の修正ボタンの戻り先
    getReturnServiceTypeMigrationDate() {
      let serviceType = ''

      if (this.regist_data.neo && this.regist_data.neo.migration_url && this.regist_data.chat && this.regist_data.chat.migration_url) {
        serviceType = 'both'
      }
      else if (this.regist_data.neo && this.regist_data.neo.migration_url) {
        serviceType = 'neo'
      }
      else if (this.regist_data.chat && this.regist_data.chat.migration_url) {
        serviceType = 'chat'
      }

      return serviceType
    },
    // ご契約種別のフラグ値変換
    contract_type() {
      return lang_od_order_tbl.plan_type[this.regist_data.customer_info.contract_type]
    },
    // お支払い方法のフラグ値変換
    payment_method() {
      return lang_cl_client_tbl.payment_type[this.regist_data.customer_info.payment_method]
    },
    // セキュアブラウザ.端末認証のフラグ値変換
    secure_browser_terminal() {
      let text = ''
      if (this.regist_data.neo.security.secure.secure_browser_terminal === '01') {
        text = 'なし'
      }
      else if (this.regist_data.neo.security.secure.secure_browser_terminal === '02') {
        text = 'あり'
      }

      return text
    },
    // メールボックス容量
    cyber_capacity() {
      switch (this.regist_data.neo.mail.cyber.mailbox) {
        case '01':
          return '5GB'
        case '02':
          return '10GB'
        case '03':
          return '50GB'
        case '04':
          return '100GB'
        default:
          return '（容量を選択してください）'
      }
    },
    // メールアーカイブ保存期間
    mail_keep() {
      switch (this.regist_data.neo.mail.cyber.keep) {
        case '01':
          return '5年保存'
        case '02':
          return '7年保存'
        default:
          return '（保存期間を選択してください）'
      }

    }
  },
}
</script>

<style scoped>
.message-border-style {
  border-width: 2px !important;
}
.title-bg-color {
  background-color: #f2ffff;
}
.chat-title-bg-color {
  background-color: #f0ffe0;
}
.plan-title-bg-color {
  background-color: #fceaee;
}
.plan-border-color {
  border-color: #eb6ea0 !important;
}
.customer-title-bg-color {
  background-color: #f5f5f5;
}
.label-font-size {
  font-size: 16px;
}
.anchor-button {
  height: 22px;
  vertical-align: center;
  text-align: center;
  margin-top: -2px;
  padding-top: 0;
}
.overflow {
  overflow: auto;
}
.white-space {
  white-space: pre-wrap;
}
.logo_desknets {
  width:100px;
  height: auto;
}
.logo_chatluck {
  width:100px;
  height: auto;
}
.logo_appsuite {
  width:100px;
  height: auto;
}
</style>
